import { render, staticRenderFns } from "./PrintPosFactura.vue?vue&type=template&id=f0dad862"
import script from "./PrintPosFactura.vue?vue&type=script&lang=js"
export * from "./PrintPosFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports